import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { useBuyItem, useShop } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { useUIStore } from '@/store/uiStore';
import { formatNumber } from '@/lib/format';
import { hapticNotify } from '@/lib/telegram';

export function ShopModal() {
  const open = useUIStore((s) => s.isModalOpen('shop'));
  const closeModal = useUIStore((s) => s.closeModal);
  const pushNotification = useUIStore((s) => s.pushNotification);
  const userId = useAuthStore((s) => s.userId);
  const { data, isLoading } = useShop(userId, open);
  const buy = useBuyItem(userId ?? 0);

  if (!open) return null;
  const items = data?.items ?? [];
  const discount = data?.vip_discount_pct ?? 0;

  return (
    <Modal open={open} onClose={() => closeModal('shop')} title={data?.location_name ?? 'Магазин'} size="lg">
      <div className="p-4 space-y-3">
        <div className="flex items-center justify-between text-sm">
          <div className="space-x-3">
            <span className="text-gold">🪙 {formatNumber(data?.player_gold ?? 0)}</span>
            <span className="text-stardust">⭐ {formatNumber(data?.player_stardust ?? 0)}</span>
          </div>
          {discount > 0 && (
            <span className="text-xs text-accent">VIP −{discount}%</span>
          )}
        </div>
        {isLoading && <div className="text-white/40 text-sm">Загружаем…</div>}
        {!isLoading && items.length === 0 && (
          <div className="text-white/40 text-sm">Сейчас тут ничего нет.</div>
        )}
        <div className="space-y-2">
          {items.map((item) => {
            const price = Math.ceil(item.price * (1 - discount / 100));
            return (
              <div
                key={item.item_id}
                className="flex items-center gap-3 bg-bg-elevated rounded-xl border border-white/5 p-3"
              >
                {item.icon && (
                  <img
                    src={`/data/items/${item.icon}`}
                    alt={item.name}
                    className="w-10 h-10 object-contain"
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = 'none';
                    }}
                  />
                )}
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-white font-medium truncate">
                    {item.name}
                  </div>
                  {item.description && (
                    <div className="text-[11px] text-white/50 line-clamp-2">
                      {item.description}
                    </div>
                  )}
                </div>
                <Button
                  size="sm"
                  disabled={buy.isPending}
                  onClick={async () => {
                    try {
                      const res = await buy.mutateAsync({
                        item_id: item.item_id,
                        quantity: 1,
                      });
                      if (res.success) {
                        hapticNotify('success');
                        pushNotification({
                          type: 'success',
                          message: `Куплено: ${item.name}`,
                        });
                      } else {
                        hapticNotify('error');
                        pushNotification({
                          type: 'error',
                          message: res.error ?? 'Покупка не удалась',
                        });
                      }
                    } catch (err) {
                      hapticNotify('error');
                      const message =
                        err instanceof Error ? err.message : 'Не удалось купить';
                      pushNotification({ type: 'error', message });
                    }
                  }}
                >
                  {item.currency === 'stardust' ? '⭐' : '🪙'} {formatNumber(price)}
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
}
